import { useTranslation } from 'react-i18next';
import LanguageToggle from './components/LanguageToggle';
// import ApkDownloadModal from './components/ApkDownloadModal';

function App() {
  const { t } = useTranslation();
  // const [isApkModalOpen, setIsApkModalOpen] = useState(false);

  // Use official badge images
  const getAppStoreBadge = () => {
    return '/images/get-it-on-app-store-new.png';
  };

  const getGooglePlayBadge = () => {
    return '/images/get-it-on-google-play-new.png';
  };

  // const handleAndroidDownload = () => {
  // setIsApkModalOpen(true);
  // };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-background-primary/95 backdrop-blur-lg border-b border-white/10 py-4">
        <div className="max-w-6xl mx-auto px-5 flex justify-between items-center">
          <div className="logo">
            <img
              src="/images/logo-with-text-white.svg"
              alt="Spice Up"
              className="h-8 md:h-10 w-auto"
            />
          </div>
          <div className="flex items-center gap-4">
            <nav className="hidden md:flex gap-8">
              <a href="#features" className="text-white text-sm font-medium hover:text-primary-500 transition-colors duration-300">
                {t('header.features')}
              </a>
              <a href="https://onelink.to/swingers" target="_blank" className="text-white text-sm font-medium hover:text-primary-500 transition-colors duration-300">
                {t('header.download')}
              </a>
            </nav>
            <LanguageToggle />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-background-primary via-background-secondary to-slate-900 pt-32 pb-20 min-h-screen flex items-center relative overflow-hidden">
        {/* Geometric background elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500/10 transform rotate-45 translate-x-48 -translate-y-48"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-secondary-500/10 transform rotate-12 -translate-x-36 translate-y-36"></div>

        <div className="max-w-6xl mx-auto px-5 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            <div className="text-center lg:text-left rtl:lg:text-right">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6 text-white tracking-tight transform hover:scale-105 transition-transform duration-300">
                {t('hero.title')}
              </h1>
              <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed font-medium">
                {t('hero.subtitle')}
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start rtl:lg:justify-end" id="download">
                {/* App Store Badge */}
                <a
                  href="https://apps.apple.com/us/app/spiceup-%D7%A7%D7%94%D7%99%D7%9C%D7%AA-%D7%94%D7%A1%D7%95%D7%95%D7%99%D7%A0%D7%A8%D7%99%D7%9D/id6743415753"
                  target="_blank"
                  className="group cursor-pointer transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(0,0,0,0.4)] hover:scale-105"
                  aria-label={t('hero.appStore')}
                >
                  <img
                    src={getAppStoreBadge()}
                    alt={t('hero.appStore')}
                    className="h-14 w-auto transform group-hover:scale-105 transition-transform duration-300"
                  />
                </a>

                {/* Google Play Badge */}
                <a
                  href="https://play.google.com/store/apps/details?id=com.swingers.matching"
                  target="_blank"
                  className="group cursor-pointer transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(236,53,109,0.4)] hover:scale-105"
                  aria-label={t('hero.googlePlay')}
                >
                  <img
                    src={getGooglePlayBadge()}
                    alt={t('hero.googlePlay')}
                    className="h-14 w-auto transform group-hover:scale-105 transition-transform duration-300"
                  />
                </a>
              </div>
            </div>
            <div className="flex justify-center items-center mt-8 lg:mt-0">
              <div className="relative w-64 h-[500px] md:w-80 md:h-[600px] bg-gradient-to-br from-secondary-500 to-primary-500 rounded-[30px] p-5 shadow-2xl animate-float">
                <div className="w-full h-full bg-gray-900 rounded-[20px] overflow-hidden">
                  <div className="h-full flex flex-col">
                    <div className="h-full relative">
                      <img
                        src="/images/catchy_image_1.png"
                        alt="Spice Up"
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-transparent"></div>
                      <div className="absolute inset-0 p-5 flex flex-col">
                        <div className="text-center py-3 border-b border-gray-700/50">
                          <img
                            src="/images/app-icon.png"
                            alt="Spice Up"
                            className="h-8 w-8 mx-auto rounded-full"
                          />
                        </div>
                        <div className="flex-1 p-4 flex flex-col justify-center gap-4">
                          <div className="bg-secondary-500/20 backdrop-blur-sm border border-secondary-500/50 rounded-xl p-4 text-center">
                            <div className="text-2xl mb-2">🤤</div>
                            <div className="text-white text-sm font-medium">{t('app.hotSwaps')}</div>
                            <div className="text-gray-300 text-xs">{t('app.coupleSwapping')}</div>
                          </div>
                          <div className="bg-primary-500/20 backdrop-blur-sm border border-primary-500/50 rounded-xl p-4 text-center">
                            <div className="text-2xl mb-2">😻</div>
                            <div className="text-white text-sm font-medium">{t('app.unicornHunter')}</div>
                            <div className="text-gray-300 text-xs">{t('app.findYourThird')}</div>
                          </div>
                          <div className="bg-secondary-500/20 backdrop-blur-sm border border-secondary-500/50 rounded-xl p-4 text-center">
                            <div className="text-2xl mb-2">💦</div>
                            <div className="text-white text-sm font-medium">{t('app.privateParties')}</div>
                            <div className="text-gray-300 text-xs">{t('app.exclusiveEvents')}</div>
                          </div>
                        </div>
                        <div className="flex justify-around py-2">
                          <div className="w-12 h-12 rounded-full bg-red-500/20 border-2 border-red-500 flex items-center justify-center text-xl cursor-pointer hover:scale-110 transition-transform">
                            😈
                          </div>
                          <div className="w-12 h-12 rounded-full bg-primary-500/20 border-2 border-primary-500 flex items-center justify-center text-xl cursor-pointer hover:scale-110 transition-transform">
                            🤤
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-background-primary" id="features">
        <div className="max-w-6xl mx-auto px-5">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-center mb-12 text-white uppercase tracking-wider transform hover:scale-105 transition-transform duration-300">
            {t('features.title')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-background-card p-8 text-center border-2 border-primary-500/20 hover:border-primary-500 hover:-translate-y-4 hover:shadow-[0_25px_50px_rgba(236,53,109,0.3)] hover:bg-gradient-to-br hover:from-background-card hover:to-primary-500/10 transition-all duration-300 group relative overflow-hidden">
              <div className="absolute top-0 right-0 rtl:left-0 rtl:right-auto w-16 h-16 bg-primary-500/10 transform rotate-45 translate-x-8 rtl:-translate-x-8 -translate-y-8 group-hover:bg-primary-500/20 transition-colors duration-300"></div>
              <img src="/images/catchy_image_1.png" alt="No Vanilla" className="w-full h-48 object-cover rounded-lg mb-4 transform group-hover:scale-105 transition-transform duration-300 object-top" />
              <h3 className="text-xl font-black mb-4 text-primary-500 uppercase tracking-wider">{t('features.noVanilla.title')}</h3>
              <p className="text-gray-300 leading-relaxed font-medium">{t('features.noVanilla.description')}</p>
            </div>
            <div className="bg-background-card p-8 text-center border-2 border-secondary-500/20 hover:border-secondary-500 hover:-translate-y-4 hover:shadow-[0_25px_50px_rgba(85,52,163,0.3)] hover:bg-gradient-to-br hover:from-background-card hover:to-secondary-500/10 transition-all duration-300 group relative overflow-hidden">
              <div className="absolute top-0 right-0 rtl:left-0 rtl:right-auto w-16 h-16 bg-secondary-500/10 transform rotate-45 translate-x-8 rtl:-translate-x-8 -translate-y-8 group-hover:bg-secondary-500/20 transition-colors duration-300"></div>
              <img src="/images/catchy_image_2.png" alt="Couples Paradise" className="w-full h-48 object-cover rounded-lg mb-4 transform group-hover:scale-105 transition-transform duration-300 object-top" />
              <h3 className="text-xl font-black mb-4 text-secondary-500 uppercase tracking-wider">{t('features.couplesParadise.title')}</h3>
              <p className="text-gray-300 leading-relaxed font-medium">{t('features.couplesParadise.description')}</p>
            </div>
            <div className="bg-background-card p-8 text-center border-2 border-primary-500/20 hover:border-primary-500 hover:-translate-y-4 hover:shadow-[0_25px_50px_rgba(236,53,109,0.3)] hover:bg-gradient-to-br hover:from-background-card hover:to-primary-500/10 transition-all duration-300 group relative overflow-hidden md:col-span-2 lg:col-span-1">
              <div className="absolute top-0 right-0 rtl:left-0 rtl:right-auto w-16 h-16 bg-primary-500/10 transform rotate-45 translate-x-8 rtl:-translate-x-8 -translate-y-8 group-hover:bg-primary-500/20 transition-colors duration-300"></div>
              <img src="/images/catchy_image_3.png" alt="Secret Playground" className="w-full h-48 object-cover rounded-lg mb-4 transform group-hover:scale-105 transition-transform duration-300 object-top" />
              <h3 className="text-xl font-black mb-4 text-primary-500 uppercase tracking-wider">{t('features.secretPlayground.title')}</h3>
              <p className="text-gray-300 leading-relaxed font-medium">{t('features.secretPlayground.description')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Screenshots Section */}
      <section className="py-20 bg-gradient-to-br from-background-secondary to-background-primary">
        <div className="max-w-6xl mx-auto px-5">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-center mb-12 text-white uppercase tracking-wider transform hover:scale-105 transition-transform duration-300">
            {t('screenshots.title')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-background-card p-8 text-center border-2 border-primary-500/20 hover:border-primary-500 hover:-translate-y-4 hover:shadow-[0_25px_50px_rgba(236,53,109,0.3)] hover:bg-gradient-to-br hover:from-background-card hover:to-primary-500/10 transition-all duration-300 group relative overflow-hidden">
              <div className="absolute top-0 right-0 rtl:left-0 rtl:right-auto w-16 h-16 bg-primary-500/10 transform rotate-45 translate-x-8 rtl:-translate-x-8 -translate-y-8 group-hover:bg-primary-500/20 transition-colors duration-300"></div>
              <div className="text-6xl mb-6 transform group-hover:scale-110 transition-transform duration-300">😈</div>
              <h3 className="text-xl font-black mb-4 text-primary-500 uppercase tracking-wider">{t('screenshots.coupleBrowsing.title')}</h3>
              <p className="text-gray-300 leading-relaxed font-medium">{t('screenshots.coupleBrowsing.description')}</p>
            </div>
            <div className="bg-background-card p-8 text-center border-2 border-secondary-500/20 hover:border-secondary-500 hover:-translate-y-4 hover:shadow-[0_25px_50px_rgba(85,52,163,0.3)] hover:bg-gradient-to-br hover:from-background-card hover:to-secondary-500/10 transition-all duration-300 group relative overflow-hidden">
              <div className="absolute top-0 right-0 rtl:left-0 rtl:right-auto w-16 h-16 bg-secondary-500/10 transform rotate-45 translate-x-8 rtl:-translate-x-8 -translate-y-8 group-hover:bg-secondary-500/20 transition-colors duration-300"></div>
              <div className="text-6xl mb-6 transform group-hover:scale-110 transition-transform duration-300">🤤</div>
              <h3 className="text-xl font-black mb-4 text-secondary-500 uppercase tracking-wider">{t('screenshots.steamyChats.title')}</h3>
              <p className="text-gray-300 leading-relaxed font-medium">{t('screenshots.steamyChats.description')}</p>
            </div>
            <div className="bg-background-card p-8 text-center border-2 border-primary-500/20 hover:border-primary-500 hover:-translate-y-4 hover:shadow-[0_25px_50px_rgba(236,53,109,0.3)] hover:bg-gradient-to-br hover:from-background-card hover:to-primary-500/10 transition-all duration-300 group relative overflow-hidden md:col-span-2 lg:col-span-1">
              <div className="absolute top-0 right-0 rtl:left-0 rtl:right-auto w-16 h-16 bg-primary-500/10 transform rotate-45 translate-x-8 rtl:-translate-x-8 -translate-y-8 group-hover:bg-primary-500/20 transition-colors duration-300"></div>
              <div className="text-6xl mb-6 transform group-hover:scale-110 transition-transform duration-300">🍆</div>
              <h3 className="text-xl font-black mb-4 text-primary-500 uppercase tracking-wider">{t('screenshots.privatePartiesFeature.title')}</h3>
              <p className="text-gray-300 leading-relaxed font-medium">{t('screenshots.privatePartiesFeature.description')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-secondary-500 via-primary-500 to-slate-900 text-center relative overflow-hidden">
        {/* Aggressive geometric background */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-1/4 rtl:right-1/4 rtl:left-auto w-32 h-32 bg-white transform rotate-45 -translate-y-16"></div>
          <div className="absolute bottom-0 right-1/4 rtl:left-1/4 rtl:right-auto w-40 h-40 bg-black transform rotate-12 translate-y-20"></div>
          <div className="absolute top-1/2 left-0 rtl:right-0 rtl:left-auto w-24 h-24 bg-white transform rotate-45 -translate-x-12 rtl:translate-x-12"></div>
          <div className="absolute top-1/2 right-0 rtl:left-0 rtl:right-auto w-28 h-28 bg-black transform rotate-45 translate-x-14 rtl:-translate-x-14"></div>
        </div>

        <div className="max-w-4xl mx-auto px-5 relative z-10">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 text-white drop-shadow-lg tracking-tight">{t('cta.title')}</h2>
          <p className="text-xl md:text-2xl mb-12 text-white/95 font-bold">{t('cta.subtitle')}</p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            {/* App Store Badge */}
            <a
              href="https://apps.apple.com/us/app/spiceup-%D7%A7%D7%94%D7%99%D7%9C%D7%AA-%D7%94%D7%A1%D7%95%D7%95%D7%99%D7%A0%D7%A8%D7%99%D7%9D/id6743415753"
              target="_blank"
              className="group cursor-pointer transition-all duration-300 hover:-translate-y-3 hover:shadow-[0_25px_50px_rgba(0,0,0,0.6)] hover:scale-110"
              aria-label={t('hero.appStore')}
            >
              <img
                src={getAppStoreBadge()}
                alt={t('hero.appStore')}
                className="h-16 w-auto transform group-hover:scale-105 transition-transform duration-300"
              />
            </a>

            {/* Google Play Badge */}
            <a
              href="https://play.google.com/store/apps/details?id=com.swingers.matching"
              target="_blank"
              // onClick={handleAndroidDownload}
              className="group cursor-pointer transition-all duration-300 hover:-translate-y-3 hover:shadow-[0_25px_50px_rgba(255,255,255,0.3)] hover:scale-110"
              aria-label={t('hero.googlePlay')}
            >
              <img
                src={getGooglePlayBadge()}
                alt={t('hero.googlePlay')}
                className="h-16 w-auto transform group-hover:scale-105 transition-transform duration-300"
              />
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-background-footer py-16 border-t border-white/10">
        <div className="max-w-6xl mx-auto px-5">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
            <div className="text-center lg:text-left rtl:lg:text-right">
              <img
                src="/images/logo-with-text-white.svg"
                alt="Spice Up"
                className="h-12 w-auto mx-auto lg:mx-0 rtl:lg:mx-0 mb-2"
              />
              <p className="text-gray-300">{t('footer.tagline')}</p>
            </div>
            <div className="text-center lg:text-left rtl:lg:text-right">
              <ul className="flex flex-col sm:flex-row gap-8 justify-center lg:justify-start rtl:lg:justify-end">
                <li><a href="https://spice-up.app/privacy-policy.html" className="text-gray-300 hover:text-primary-500 transition-colors text-sm font-medium">{t('footer.privacyPolicy')}</a></li>
                <li><a href="https://spice-up.app/terms-and-conditions.html" className="text-gray-300 hover:text-primary-500 transition-colors text-sm font-medium">{t('footer.termsConditions')}</a></li>
              </ul>
            </div>
            <div className="text-center lg:text-left rtl:lg:text-right">
              <h4 className="text-white font-semibold mb-4">{t('footer.followUs')}</h4>
              <div className="flex gap-4 justify-center lg:justify-start rtl:lg:justify-end">
                <a
                  href="https://www.instagram.com/spice_up.app?igsh=MTFpd2Y5N2x6eGptcw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-primary-500 transition-colors duration-300 group"
                  aria-label={t('footer.instagram')}
                >
                  <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </div>
                </a>
                <a
                  href="https://www.facebook.com/share/16y39Fhgt3/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-primary-500 transition-colors duration-300 group"
                  aria-label={t('footer.facebook')}
                >
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="text-center border-t border-white/10 pt-8">
            <p className="text-gray-400 text-sm">{t('footer.copyright')}</p>
          </div>
        </div>
      </footer>
      {/* <ApkDownloadModal isOpen={isApkModalOpen} onClose={() => setIsApkModalOpen(false)} /> */}
    </div>
  );
}

export default App; 